import { toast } from 'react-toastify';
import API from '../apiClient';
  export const AdminOrganizationAccount = (payload) => {
      return new Promise((resolve) => {
          API.post(`/account`, payload)
          .then(response => {
              resolve(response);
          }) .catch(error =>{
            toast.error("Something went wrong")
            console.log(error)
          });
      })
  
  }